<div style="width: auto; overflow: auto">
  <app-common-list-table
          [request]="getRequest"
          [cols]="cols"
          [globalConditionalStyle]="globalConditionalStyle"
          [globalVisualTransform]="globalVisualTransform"
          [filtering]="filter"

          [actionButtonText]="env.canAddSectores ? btnAnadir : ''"
          (actionButtonClick)="add()"
          (emitSearchText)="updateFooter()"
          (visualize)="show('info', $event)"
          (edit)="edit($event)"
          (remove)="show('delete', $event)">

    <ng-template #header>
      @if (env.appName === 'avafitogest') {
        <div class="ms-5">
          <button class="btn btn-primary" (click)="openDocumentInNewTab()">Obligación GIP</button>
        </div>
      }
    </ng-template>
    
    <ng-template #thEnd>
      <th class="rt-actions-col">
        <p class="d-flex justify-content-center"
           style="margin-bottom: 0">Acciones</p>
      </th>
    </ng-template>

    <ng-template #tdEnd let-data>
      <td class="rt-actions-col">
        <app-action-buttons
          [hideEdit]="!env.canEditSectores"
          [hideDelete]="!env.canDeleteSectores"   
          (editRowButtonEvent)="edit(data.data)"
          (deleteRowButtonEvent)="show('delete', data.data)"
          (showRowButtonEvent)="show('info', data.data)">
        </app-action-buttons>
      </td>
    </ng-template>

    <ng-template #footer let-col>
      <div style="font-size: 0.75em; text-align: left" *ngIf="(['nombre'].includes(col.field))">
        TOTAL:
      </div>
      <div *ngIf="(['sup_cultivada', 'total_plantas'].includes(col.field))"
        style="font-size: 0.75em; text-align: right; font-weight: bold; padding-right: 34px">
        {{col?.footer || 0}}
      </div>
    </ng-template>
  </app-common-list-table>
</div>

<!-- Shared modals host -->
<app-modals
  [view]="this"
  [form]="form?.formFields"
  [serverUrl]="env.serverUrl"
  [previousData]="model"
  [recordHasAssociatedData]="true"
  [getRequest]="getRequest"
  [deleteRequest]="deleteRequest">
</app-modals>